/**
 * Lectura del latido de la cola (`estado_cola/caes-confirm-chunks`, BB-2623) para el registro.
 *
 * Separada como `confirmStatusFirestore.ts`: `auditLog.ts` no importa el SDK y se testea en node. Aquí
 * solo se lee y se valida con el esquema del contrato; la interpretación es `aplicarLatido`.
 *
 * `null` en todos los casos raros (documento que aún no existe porque el backend de BB-2623 no está
 * desplegado o no ha pagado ninguna tanda, forma que no valida, fecha ilegible): con `null` el registro
 * se pinta exactamente como antes de BB-2625. Nunca se inventa un latido.
 */
import { doc, getDoc } from 'firebase/firestore';

import { latidoDeDocumento, type LatidoCola } from './auditLog';
import { db } from './firebase';

export async function leerLatidoCola(): Promise<LatidoCola | null> {
  const snap = await getDoc(doc(db, 'estado_cola', 'caes-confirm-chunks'));
  if (!snap.exists()) return null;
  return latidoDeDocumento(snap.data());
}
